/**
 * apps/admin/src/components/intercom-messenger.tsx · Intercom Messenger 挂载点
 *
 * 挂在 __root.tsx 的 PasswordGate 内部：过了访问门才 boot，锁屏页不出现悬浮气泡。
 * 逻辑全在 @/lib/intercom（app_id / 身份 / 启用条件单点收口），这里只负责生命周期。
 */
import { useEffect } from "react";

import { useRouterState } from "@tanstack/react-router";

import { bootIntercom, updateIntercomOnRouteChange } from "@/lib/intercom";

export function IntercomMessenger() {
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	useEffect(() => {
		bootIntercom();
	}, []);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pathname 只作换页触发器，update 自己读 window.location
	useEffect(() => {
		updateIntercomOnRouteChange();
	}, [pathname]);

	return null;
}
